function toId(value) {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }
  if (typeof value !== 'string') {
    return null;
  }
  const text = value.trim();
  if (/^[0-9]+$/.test(text)) {
    return toId(Number(text));
  }
  // Prefixed ids (t-2a3f, exp-14e8, p-d69) are hexadecimal.
  const prefixed = /^[a-z]+-([0-9a-f]+)$/i.exec(text);
  return prefixed ? toId(parseInt(prefixed[1], 16)) : null;
}

// defaultValues come from the schema form and take precedence over the component props.
export function trainerContext(defaultValues, props) {
  const defaults = defaultValues || {};
  const fromProps = props || {};
  return {
    projectId: toId(defaults.project_id) ?? toId(fromProps.projectID),
    experimentId: toId(defaults.experiment_id) ?? toId(fromProps.experimentID),
    sessionId: toId(defaults.train_session_id),
  };
}

export function artifactName(artifact) {
  if (!artifact) {
    return '';
  }
  return typeof artifact === 'string' ? artifact : artifact.name || '';
}

export function filterArtifacts(artifacts, filter) {
  const list = Array.isArray(artifacts) ? artifacts : [];
  if (!Array.isArray(filter) || filter.length === 0) {
    return list;
  }
  const extensions = filter.map((ext) => String(ext).toLowerCase());
  return list.filter((artifact) => {
    const name = artifactName(artifact).toLowerCase();
    return extensions.some((ext) => name.endsWith(ext));
  });
}

export function pickArtifact(artifacts, preferred) {
  const names = (artifacts || []).map(artifactName);
  if (preferred && names.includes(preferred)) {
    return preferred;
  }
  return names[0] || '';
}

export function artifactsFilterLabel(filter) {
  return Array.isArray(filter) ? filter.join(', ') : '';
}

export function isTrainerValueComplete(field, value) {
  if (!value || (!value.train_session_id && !value.session_id)) {
    return false;
  }
  return !field?.enable_artifacts || !!value.artifact;
}
